import i18n from '@i18next/i18n';

// 支持创建/修改的图表类型
export enum PresetChartType {
    COLUMN_CLUSTERED,                        // 簇状柱状图
    COLUMN_STACKED,                          // 堆积柱状图
    COLUMN_PERCENT_STACKED,                  // 百分比堆积柱状图

    BAR_CLUSTERED,                           // 簇状条形图
    BAR_STACKED,                             // 堆积条形图
    BAR_PERCENT_STACKED,                     // 百分比堆积条形图

    LINE_STANDARD,                           // 折线图
    LINE_STACKED,                            // 堆积折线图
    LINE_PERCENT_STACKED,                    // 百分比堆积折线图
    LINE_STANDARD_WITH_POINT,                // 带点的折线图
    LINE_STACKED_WITH_POINT,                // 带点的堆积折线图
    LINE_PERCENT_STACKED_WITH_POINT,        // 带点的百分比堆积折线图

    PIE,                                    // 饼图
    OF_PIE,                                 // 子母饼图
    OF_PIE_BAR,                             // 复合饼图
    DOUGHNUT,                               // 圆环图

    AREA,                                   // 面积图
    AREA_STACKED,                           // 堆积面积图
    AREA_PERCENT_STACKED,                   // 百分比堆积面积图

    RADAR,                                  // 雷达图
    RADAR_WITH_POINT,                       // 带数据标记的雷达图
    RADAR_WITH_FILL,                        // 填充雷达图

    SCATTER,                                // 散点图
    SCATTER_WITH_STRAIGHTLINE,              // 带直线的散点图
    SCATTER_WITH_STRAIGHTLINE_ADN_MARKER,   // 带直线和数据标记的散点图
    SCATTER_WITH_SMOOTHLINE,                // 带平滑线的散点图
    SCATTER_WITH_SMOOTHLINE_ADN_MARKER,     // 带平滑线和数据标记的散点图
    BUBBLE,                                 // 气泡图

    STOCK,                                  // 股价图

    COMBO,                                  // 组合图
}

export const CreateChartTypeName = {
    [PresetChartType.COLUMN_CLUSTERED]: i18n.t('簇状柱状图'),
    [PresetChartType.COLUMN_STACKED]: i18n.t('堆积柱状图'),
    [PresetChartType.COLUMN_PERCENT_STACKED]: i18n.t('百分比堆积柱状图'),
    [PresetChartType.BAR_CLUSTERED]: i18n.t('簇状条形图'),
    [PresetChartType.BAR_STACKED]: i18n.t('堆积条形图'),
    [PresetChartType.BAR_PERCENT_STACKED]: i18n.t('百分比堆积条形图'),
    [PresetChartType.LINE_STANDARD]: i18n.t('折线图'),
    [PresetChartType.LINE_STACKED]: i18n.t('堆积折线图'),
    [PresetChartType.LINE_PERCENT_STACKED]: i18n.t('百分比堆积折线图'),
    [PresetChartType.LINE_STANDARD_WITH_POINT]: i18n.t('带数据标记的折线图'),
    [PresetChartType.LINE_STACKED_WITH_POINT]: i18n.t('带数据标记的堆积折线图'),
    [PresetChartType.LINE_PERCENT_STACKED_WITH_POINT]: i18n.t('带数据标记的百分比堆积折线图'),
    [PresetChartType.PIE]: i18n.t('饼图'),
    [PresetChartType.OF_PIE]: i18n.t('子母饼图'),
    [PresetChartType.OF_PIE_BAR]: i18n.t('复合饼图'),
    [PresetChartType.DOUGHNUT]: i18n.t('圆环图'),
    [PresetChartType.AREA]: i18n.t('面积图'),
    [PresetChartType.AREA_STACKED]: i18n.t('堆积面积图'),
    [PresetChartType.AREA_PERCENT_STACKED]: i18n.t('百分比堆积面积图'),
    [PresetChartType.RADAR]: i18n.t('雷达图'),
    [PresetChartType.RADAR_WITH_POINT]: i18n.t('带数据标记的雷达图'),
    [PresetChartType.RADAR_WITH_FILL]: i18n.t('填充雷达图'),
    [PresetChartType.SCATTER]: i18n.t('散点图'),
    [PresetChartType.SCATTER_WITH_STRAIGHTLINE]: i18n.t('带直线的散点图'),
    [PresetChartType.SCATTER_WITH_STRAIGHTLINE_ADN_MARKER]: i18n.t('带直线和数据标记的散点图'),
    [PresetChartType.SCATTER_WITH_SMOOTHLINE]: i18n.t('带平滑线的散点图'),
    [PresetChartType.SCATTER_WITH_SMOOTHLINE_ADN_MARKER]: i18n.t('带平滑线和数据标记的散点图'),
    [PresetChartType.BUBBLE]: i18n.t('气泡图'),
    [PresetChartType.STOCK]: i18n.t('股价图'),
    [PresetChartType.COMBO]: i18n.t('组合图'),
};

export const DEFAULT_SERIES_NAME = '系列';
export const seriesThemeColors = [
    {
        solidFill: {
            color: {
                colorValue: 'accent1',
                colorType: 'scheme',
            },
        },
    },
    {
        solidFill: {
            color: {
                colorValue: 'accent2',
                colorType: 'scheme',
            },
        },
    },
    {
        solidFill: {
            color: {
                colorValue: 'accent3',
                colorType: 'scheme',
            },
        },
    },    {
        solidFill: {
            color: {
                colorValue: 'accent4',
                colorType: 'scheme',
            },
        },
    },
    {
        solidFill: {
            color: {
                colorValue: 'accent5',
                colorType: 'scheme',
            },
        },
    },
    {
        solidFill: {
            color: {
                colorValue: 'accent6',
                colorType: 'scheme',
            },
        },
    },
];


export const DEFAULT_CHART_SERIES_CATEGORIES_PRESET = ['类别 1', '类别 2', '类别 3', '类别 4'];
export const DEFAULT_CHART_VALUES_PRESET = [
    [4.3, 2.5, 3.5, 4.5],
    [2.4, 4.4, 1.8, 2.8],
    [2, 2, 3, 5],
];

export const DEFAULT_SHAPE_PROPS = {
    style: {
        fillBackground: { noFill: 1 },
        border: { noFill: 1 },
        effect: {},
    },
};
export const DEFAULT_TITLE_FONT_SIZE = 18.62;
export const DEFAULT_AXIS_FONT_SIZE = 11.97;
export const DEFAULT_LEGEND_FONT_SIZE = 11.97;
export const DEFAULT_DATA_LABEL_FONT_SIZE = 11.97;

export const INITIAL_AXES_INDEX = 0;
